import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import logoeasycampus from "../../public/images/logo-easycampus.png";
import { capitalizeFirstLetter, dateFormatForUser } from "@/utils/common";



const Blogsslider = ({blogDetails}) => {
  const [currentDate, setCurrentDate] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const [sliderBlogData, setSliderBlogData] = useState([]);

  useEffect(() => {

    console.log("blogDetails",blogDetails);
    
    setSliderBlogData(blogDetails)

    // const updateDateTime = () => {
    //   const now = new Date();
    //   const month = now.toLocaleString('default', { month: 'short' });
    //   const day = now.getDate();
    //   const year = now.getFullYear();
    //   const hours = now.getHours();
    //   const minutes = now.getMinutes();
    //   const seconds = now.getSeconds();

    //   setCurrentDate(`${month} ${day}, ${year}`);
    //   setCurrentTime(`${hours}:${minutes}:${seconds}`);
    // };

    // const intervalId = setInterval(updateDateTime, 1000);
    // return () => clearInterval(intervalId);
  }, []);

  function getWordCountFromHTMLAndCalculateReadTime(htmlContent) {
    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    console.log("htmlContent",htmlContent);
    
  
    // Extract the text from the div (this removes all the tags)
    const text = tempDiv.innerText || tempDiv.textContent;
  
    // Split the text into words, filter out any empty strings, and count the words
    const words = text.trim().split(/\s+/).filter(word => word.length > 0);

    console.log("words.length",words.length);
    
  
    const wordsPerMinute = 200; // Average reading speed
      const minutes = Math.ceil(words.length / wordsPerMinute); // Round up to nearest minute
      return `-${minutes} min`;
  
    // return words.length;
  }

  const decodeHtml = (html) => {
    if (typeof window !== "undefined") {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
    // Return the input as is if running on the server
    return html;
  };

  function truncateHtml(html, maxLength) {
    if (typeof window === "undefined") {
      // If running on the server, return the plain HTML as is or handle it differently
      return html?.substring(0, maxLength) || "";
     //return html;
      
    }
  
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    let truncated = "";
    let charCount = 0;
  
    const traverseNodes = (node) => {
      if (charCount >= maxLength) return;
  
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (charCount + text.length > maxLength) {
          truncated += text.substring(0, maxLength - charCount);
          charCount = maxLength;
        } else {
          truncated += text;
          charCount += text.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        truncated += `<${node.tagName.toLowerCase()}${
          node.getAttribute("style")
            ? ` style="${node.getAttribute("style")}"`
            : ""
        }>`;
        for (let i = 0; i < node.childNodes.length; i++) {
          traverseNodes(node.childNodes[i]);
          if (charCount >= maxLength) break;
        }
        truncated += `</${node.tagName.toLowerCase()}>`;
      }
    };
  
    for (let i = 0; i < tempDiv.childNodes.length; i++) {
      traverseNodes(tempDiv.childNodes[i]);
      if (charCount >= maxLength) break;
    }
  
    return truncated;
  }

  return (
    <>
      <div className='my-20'>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          initialSlide={1}
          speed={2500}
          loop={true}
          roundLengths={true}
          mousewheel={true}
          grabCursor={true}
          centeredSlides={true}
          autoplay={{
            delay: 7500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
          breakpoints={{
            '@0.00': {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            '@0.75': {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            '@1.00': {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            '@1.50': {
              slidesPerView: 2,
              spaceBetween: 10,
            },
          }}
        >
          {sliderBlogData.map((sliderBlog, index) => (
            <SwiperSlide key={index}>
              <div className='relative'>
                <Image src={sliderBlog.blogImageUrl} alt={`campus recruitment meaning${index + 1}`} width={600} height={800} className='w-full h-[70vh]' />
                <div className='bg-[#ffffffbc] absolute right-0 bottom-5 p-7 flex items-start'>
                  <Image src={logoeasycampus} alt="campus placements" className="w-14 h-14" />
                  <div className="text-left ml-2">
                    <p>{'Easy Campus'}</p>
                    <p>{dateFormatForUser(sliderBlog?.created_at)} {getWordCountFromHTMLAndCalculateReadTime(sliderBlog?.blogDescription)}</p>
                
                    <h6>{capitalizeFirstLetter(sliderBlog.blogTitle)}</h6>
                    {/* <div className='' 
                      dangerouslySetInnerHTML={{
                        __html: capitalizeFirstLetter(truncateHtml(
                          decodeHtml(sliderBlog?.blogDescription),
                          120
                        )),
                      }}
                    /> */}
                    {/* <p className="my-2">{capitalizeFirstLetter(blog?.description)}</p> */}
                  <Link 
                  href={`/blog/${sliderBlog.blogUrl}`}
                  >
                  <button className="flex justify-items-start blogreadmorebtn">Read More</button></Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default Blogsslider;

